<price-modal>
    <div class="modal" tabindex="-1" role="dialog" ref="modal">
        <div if="{opts.offer.id}" class="modal-dialog" style="min-width: 50% !important;" role="document">
            <div class="modal-content" style="">
                <div class="modal-header" style="padding-top:0">
                    <br>
                </div>
                <div class="modal-body" style="">
                    <div class="container-fluid" style="padding: 0;margin: 0">
                        <div class="row">
                            <div class="col-md-12">
                                <h5 class="block-title hint-text text-center no-margin"><b>{opts.offer.name}</b></h5>
                                <hr>
                                <offer-price
                                    offer="{opts.offer}"
                                    add-to-cart="{opts.addToCart}"
                                ></offer-price>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <script>

        // import components

        import '../../components/pricing/offer-price.tag.html';

        // import styles


        const tag = this;



        tag.on('mount', () => {
            tag.modal = $(tag.refs.modal);
        });

        tag.toggle = () => {
            tag.modal.modal('toggle')
        };

        tag.close = () => {
            tag.modal.modal('hide')
        };

    </script>
</price-modal>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/pricing/price-modal.tag.html